<template>
    <el-row id="collectField">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnBack="true" @btnBackClick="handleBackClick" />
        <el-row>
            <el-row style="margin-top: 15px;">
                <el-col :span="12">
                    <el-button
                        style="color: #fff;font-size: 12px;background: #4EC880;border:1px solid #4EC880;border-radius: 5px;"
                        @click.stop="handleAddClick" icon="el-icon-plus" size="small">
                        添加字段
                    </el-button>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <p style="font-size: 16px;color: #4A90E2;margin:0;line-height: 36px;">
                        采集字段总数：{{collectFieldList.length}}个</p>
                </el-col>
            </el-row>
            <el-row style="margin-top: 15px;">
                <el-tabs refs="tabs" v-model="activeName" @tab-click="tabHandleClick" style="height: 100%"
                    class="eltabs">
                    <el-tab-pane v-if="tabShow.showInstitution" label="医疗机构" name="INSTITUTION"
                        style="overflow-y: auto;">

                        <el-table :data="collectFieldList" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="reference_obj" label="对象" width="100" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.reference_obj == 'HCP'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        HCP
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'INSTITUTION'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        机构
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'RETAILSTORE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        门店
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        经销商
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="label" label="字段" sortable>
                                <template slot-scope="scope">
                                    {{getFieldShowText(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="日期采集范围" width="250" sortable>
                            </el-table-column>
                            <el-table-column prop="address" label="产品采集范围" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.skuList.length == 0 && scope.row.proList.length == 0">
                                        所有产品
                                    </span>
                                    <span v-for="(item,index) in scope.row.proList" :key="index">
                                        {{(index != scope.row.proList.length - 1 || scope.row.skuList.length != 0) ?
                                        item.product_name+'、' : item.product_name}}

                                    </span>
                                    <span v-for="(item,j) in scope.row.skuList" :key="j">
                                        {{j != scope.row.skuList.length - 1 ? item.sku_name+'、' : item.sku_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zip" label="科室采集范围" sortable>
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.reference_obj == 'INSTITUTION' && scope.row.deptList.length == 0">
                                        所有科室
                                    </span>
                                    <span
                                        v-if="scope.row.reference_obj == 'HCP' || scope.row.reference_obj == 'RETAILSTORE' || scope.row.reference_obj == 'DISTRIBUTOR'">
                                        -
                                    </span>
                                    <span v-for="(item,index) in scope.row.deptList" :key="index">
                                        {{index != scope.row.deptList.length - 1 ? item.title+'、' : item.title}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="HCP" v-if="tabShow.showHcp" name="HCP" style="overflow-y: auto;">
                        <el-table :data="collectFieldList" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="reference_obj" label="对象" width="100" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.reference_obj == 'HCP'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        HCP
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'INSTITUTION'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        机构
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'RETAILSTORE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        门店
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        经销商
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="label" label="字段" sortable>
                                <template slot-scope="scope">
                                    {{getFieldShowText(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="日期采集范围" width="250" sortable>
                            </el-table-column>
                            <el-table-column prop="address" label="产品采集范围" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.skuList.length == 0 && scope.row.proList.length == 0">
                                        所有产品
                                    </span>
                                    <span v-for="(item,index) in scope.row.proList" :key="index">
                                        {{(index != scope.row.proList.length - 1 || scope.row.skuList.length != 0) ?
                                        item.product_name+'、' : item.product_name}}

                                    </span>
                                    <span v-for="(item,j) in scope.row.skuList" :key="j">
                                        {{j != scope.row.skuList.length - 1 ? item.sku_name+'、' : item.sku_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zip" label="科室采集范围" sortable>
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.reference_obj == 'INSTITUTION' && scope.row.deptList.length == 0">
                                        所有科室
                                    </span>
                                    <span
                                        v-if="scope.row.reference_obj == 'HCP' || scope.row.reference_obj == 'RETAILSTORE' || scope.row.reference_obj == 'DISTRIBUTOR'">
                                        -
                                    </span>
                                    <span v-for="(item,index) in scope.row.deptList" :key="index">
                                        {{index != scope.row.deptList.length - 1 ? item.title+'、' : item.title}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="门店" v-if="tabShow.showRetailstore" name="RETAILSTORE" style="overflow-y: auto;">
                        <el-table :data="collectFieldList" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="reference_obj" label="对象" width="100" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.reference_obj == 'HCP'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        HCP
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'INSTITUTION'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        机构
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'RETAILSTORE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        门店
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        经销商
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="label" label="字段" sortable>
                                <template slot-scope="scope">
                                    {{getFieldShowText(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="日期采集范围" width="250" sortable>
                            </el-table-column>
                            <el-table-column prop="address" label="产品采集范围" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.skuList.length == 0 && scope.row.proList.length == 0">
                                        所有产品
                                    </span>
                                    <span v-for="(item,index) in scope.row.proList" :key="index">
                                        {{(index != scope.row.proList.length - 1 || scope.row.skuList.length != 0) ?
                                        item.product_name+'、' : item.product_name}}

                                    </span>
                                    <span v-for="(item,j) in scope.row.skuList" :key="j">
                                        {{j != scope.row.skuList.length - 1 ? item.sku_name+'、' : item.sku_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zip" label="科室采集范围" sortable>
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.reference_obj == 'INSTITUTION' && scope.row.deptList.length == 0">
                                        所有科室
                                    </span>
                                    <span
                                        v-if="scope.row.reference_obj == 'HCP' || scope.row.reference_obj == 'RETAILSTORE' || scope.row.reference_obj == 'DISTRIBUTOR'">
                                        -
                                    </span>
                                    <span v-for="(item,index) in scope.row.deptList" :key="index">
                                        {{index != scope.row.deptList.length - 1 ? item.title+'、' : item.title}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="经销商" v-if="tabShow.showDistributor" name="DISTRIBUTOR"
                        style="overflow-y: auto;">
                        <el-table :data="collectFieldList" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="reference_obj" label="对象" width="100" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.reference_obj == 'HCP'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        HCP
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'INSTITUTION'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        机构
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'RETAILSTORE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        门店
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'DISTRIBUTOR'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        经销商
                                    </span>
                                    <span v-if="scope.row.reference_obj == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="label" label="字段" sortable>
                                <template slot-scope="scope">
                                    {{getFieldShowText(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="日期采集范围" width="250" sortable>
                            </el-table-column>
                            <el-table-column prop="address" label="产品采集范围" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.skuList.length == 0 && scope.row.proList.length == 0">
                                        所有产品
                                    </span>
                                    <span v-for="(item,index) in scope.row.proList" :key="index">
                                        {{(index != scope.row.proList.length - 1 || scope.row.skuList.length != 0) ?
                                        item.product_name+'、' : item.product_name}}

                                    </span>
                                    <span v-for="(item,j) in scope.row.skuList" :key="j">
                                        {{j != scope.row.skuList.length - 1 ? item.sku_name+'、' : item.sku_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="zip" label="科室采集范围" sortable>
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.reference_obj == 'INSTITUTION' && scope.row.deptList.length == 0">
                                        所有科室
                                    </span>
                                    <span
                                        v-if="scope.row.reference_obj == 'HCP' || scope.row.reference_obj == 'RETAILSTORE' || scope.row.reference_obj == 'DISTRIBUTOR'">
                                        -
                                    </span>
                                    <span v-for="(item,index) in scope.row.deptList" :key="index">
                                        {{index != scope.row.deptList.length - 1 ? item.title+'、' : item.title}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="自定义表格" v-if="tabShow.showCustomtable" name="CUSTOMTABLE"
                        style="overflow-y: auto;">
                        <el-table :data="collectFieldList" border style="width: 100%;">
                            <el-table-column type="index" label="序号" width="50">
                            </el-table-column>
                            <el-table-column prop="reference_obj" label="对象" width="100" sortable>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.reference_obj == 'CUSTOMTABLE'"
                                        style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                        自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="label" label="字段" sortable>
                                <template slot-scope="scope">
                                    {{getFieldShowText(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="sort" label="排序值" width="150">
                            </el-table-column>
                            <el-table-column prop="primary_key" label="主键" width="150">
                                <template slot-scope="scope">
                                    {{scope.row.primary_key==="T"?"是":"否"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="mandatory" label="必填" width="150">
                                <template slot-scope="scope">
                                    {{scope.row.mandatory==="T"?"是":"否"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" label="状态" width="150">
                                <template slot-scope="scope">
                                    {{scope.row.status==="ACTIVE"?"有效":"无效"}}
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                        size="small" @click="handleDetail(scope.row,'CUSTOMTABLE')">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-row>
        </el-row>
        <!--编辑字段 机构 hcp 门店 经销商-->
        <el-dialog :visible.sync="fieldDetails" width="700px" :show-close="false" style="vertical-align: center;">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">采集字段详情
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="upload">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="collect_field" style="margin-top: 20px;">
                    <el-form :model="uploadcollectFieldInfo" ref="ruleForm" label-width="200px" class="demo-ruleForm"
                        v-if="isfalse" hide-required-asterisk>
                        <el-form-item label="采集对象" prop="reference_obj" :rules="[
                                           { required: true, message: '采集对象不能为空'},]" class="collectField_star">
                            <el-select v-model="uploadcollectFieldInfo.reference_obj" placeholder="请选择" disabled
                                @change="getField" style="width: 70%">
                                <el-option v-for="item in collectObject" :key="item.id" :label="item.value"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采集字段" prop="field_name" :rules="[
                                           { required: true, message: '采集字段不能为空'},]" class="collectField_star">
                            <!--                            <el-select v-model="collectFieldInfo.value" placeholder="请选择" style="width: 70%">-->
                            <!--                                <el-option-->
                            <!--                                        v-for="item in options"-->
                            <!--                                        :key="item.value"-->
                            <!--                                        :label="item.label"-->
                            <!--                                        :value="item.value">-->
                            <!--                                </el-option>-->
                            <!--                            </el-select>-->
                            <el-select v-model="uploadcollectFieldInfo.field_name" placeholder="请选择" disabled
                                collapse-tags style="width: 70%;" clearable>
                                <el-option :value="mineStatusValue" style="height: auto">
                                    <el-tree class="filter-tree" :data="data" node-key="field_id"
                                        :highlight-current="true" :expand-on-click-node="false"
                                        @node-click="handleNodeClick" ref="tree3">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">

                                            <span>{{ node.label }}</span>
                                        </span>
                                    </el-tree>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="日期采集范围">
                            <el-date-picker v-model="uploadcollectFieldInfo.start_date" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 70%"
                                @change="chooseTimeRange0">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="">
                            <el-date-picker v-model="uploadcollectFieldInfo.end_date" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 70%"
                                @change="chooseTimeRange1">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="产品采集范围">
                            <el-cascader v-model="uploadcollectFieldInfo.product_id" :options="productList"
                                style="width: 70%;" :show-all-levels="false"
                                :props="{ multiple: true, checkStrictly: true }" clearable>
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="科室采集范围">
                            <el-select v-model="uploadcollectFieldInfo.dept_id" placeholder="请选择" multiple
                                :disabled="uploadcollectFieldInfo.reference_obj == 'INSTITUTION' ? false:true"
                                style="width: 70%">
                                <el-option v-for="item in deptList" :key="item.dept_code" :label="item.label"
                                    :value="item.dept_code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="排序值" prop="sort" :rules="[
                                           { required: true, message: '排序值不能为空'},]" class="collectField_star">
                            <el-input v-model="uploadcollectFieldInfo.sort" type="number" style="width: 70%"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="有效" prop="region">
                            <el-switch style="margin: 0" v-model="uploadcollectFieldInfo.status" active-color="#13ce66"
                                active-value="ACTIVE" inactive-value="INACTIVE">
                            </el-switch>
                        </el-form-item>

                    </el-form>

                </div>
            </div>

        </el-dialog>


        <!--编辑字段 自定义表格-->
        <el-dialog :visible.sync="fieldCustomTableDetails" width="700px" :show-close="false"
            style="vertical-align: center;">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">采集字段详情
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="upload">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="collect_field" style="margin-top: 20px;">
                    <el-form :model="uploadcollectFieldInfo" ref="ruleForm" label-width="200px" class="demo-ruleForm"
                        v-if="isfalse" hide-required-asterisk>
                        <el-form-item label="采集对象" prop="reference_obj" :rules="[
                                           { required: true, message: '采集对象不能为空'},]" class="collectField_star">
                            <el-select v-model="uploadcollectFieldInfo.reference_obj" placeholder="请选择" disabled
                                @change="getField" style="width: 70%">
                                <el-option v-for="item in collectObject" :key="item.id" :label="item.value"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采集字段" prop="field_name" :rules="[
                                           { required: true, message: '采集字段不能为空'},]" class="collectField_star">
                            <el-select v-model="uploadcollectFieldInfo.field_name" placeholder="请选择" disabled
                                collapse-tags style="width: 70%;" clearable>
                                <el-option :value="mineStatusValue" style="height: auto">
                                    <el-tree class="filter-tree" :data="data" node-key="field_id"
                                        :highlight-current="true" :expand-on-click-node="false"
                                        @node-click="handleNodeClick" ref="tree3">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">

                                            <span>{{ node.label }}</span>
                                        </span>
                                    </el-tree>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="默认值" prop="sort" >
                            <el-input v-model="uploadcollectFieldInfo.default_value" style="width: 70%"
                                placeholder="请输入默认值"></el-input>
                        </el-form-item>
                        <el-form-item label="排序值" prop="sort" :rules="[
                                           { required: true, message: '排序值不能为空'},]" class="collectField_star">
                            <el-input v-model="uploadcollectFieldInfo.sort" type="number" style="width: 70%"
                                placeholder="请输入排序"></el-input>
                        </el-form-item>
                        <el-form-item label="主键">
                            <el-switch style="margin: 0" v-model="uploadcollectFieldInfo.primary_key"
                                active-color="#13ce66" active-value="T" inactive-value="F">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="必填">
                            <el-switch style="margin: 0" v-model="uploadcollectFieldInfo.mandatory"
                                active-color="#13ce66" active-value="T" inactive-value="F">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="只读">
                            <el-switch style="margin: 0" v-model="uploadcollectFieldInfo.readonly"
                                active-color="#13ce66" active-value="T" inactive-value="F">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="有效" prop="region">
                            <el-switch style="margin: 0" v-model="uploadcollectFieldInfo.status" active-color="#13ce66"
                                active-value="ACTIVE" inactive-value="INACTIVE">
                            </el-switch>
                        </el-form-item>

                    </el-form>

                </div>
            </div>

        </el-dialog>

        <!--新增字段-->
        <el-dialog :visible.sync="fieldDetails1" width="700px" :show-close="false" style="vertical-align: center;">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">新增采集字段
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="add">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;">
                    <el-form :model="addcollectFieldInfo" ref="ruleForm1" label-width="200px" class="demo-ruleForm"
                        hide-required-asterisk>
                        <el-form-item label="采集对象" prop="reference_obj" :rules="[
                                           { required: true, message: '采集对象不能为空'},]" class="collectField_star">
                            <el-select v-model="addcollectFieldInfo.reference_obj" placeholder="请选择"
                                @change="getCollectFieldList" style="width: 70%">
                                <el-option v-for="item in collectObject" :key="item.id" :label="item.value"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采集字段" prop="field_array" :rules="[{ required: true, message: '采集字段不能为空'},]"
                            class="collectField_star">
                            <el-cascader style="width: 70%" v-model="addcollectFieldInfo.field_array" :filterable="true"
                                :options="data" :props="field_props" clearable></el-cascader>
                        </el-form-item>
                        <!-- <el-form-item label="采集字段" prop="field_name" :rules="[
                                           { required: true, message: '采集字段不能为空'},]" class="collectField_star">
                            <el-select v-model="addcollectFieldInfo.field_name" placeholder="请选择" collapse-tags
                                style="width: 70%;" clearable>
                                <el-option :value="mineStatusValue" style="height: auto">
                                    <el-tree class="filter-tree" :data="data" node-key="field_id"
                                        :highlight-current="true" :expand-on-click-node="false"
                                        @node-click="handleNodeClick1" ref="tree3">
                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                            <span>{{ node.label }}</span>
                                        </span>
                                    </el-tree>
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item label="日期采集范围" v-if="isDisable">
                            <el-date-picker v-model="addcollectFieldInfo.start_date" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 70%"
                                @change="chooseTimeRange2">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="" v-if="isDisable">
                            <el-date-picker v-model="addcollectFieldInfo.end_date" type="date" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 70%"
                                @change="chooseTimeRange3">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="产品采集范围" v-if="isDisable">
                            <el-cascader v-model="addcollectFieldInfo.product_id" :options="productList"
                                style="width: 70%;" :show-all-levels="false"
                                :props="{ multiple: true, checkStrictly: true }" clearable>
                            </el-cascader>
                        </el-form-item> -->
                        <!-- <el-form-item label="科室采集范围" v-if="isDisable">
                            <el-select v-model="addcollectFieldInfo.dept_id" placeholder="请选择" multiple
                                :disabled="addcollectFieldInfo.reference_obj == 'INSTITUTION' ? false:true"
                                style="width: 70%">
                                <el-option v-for="item in deptList" :key="item.key" :label="item.value1"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item label="排序值" prop="sort" :rules="[
                                           { required: true, message: '排序值不能为空'},]" class="collectField_star">
                            <el-input v-model="addcollectFieldInfo.sort" type="number" style="width: 70%"
                                placeholder="请输入"></el-input>
                        </el-form-item> -->
                        <el-form-item label="有效" prop="region">
                            <el-switch style="margin: 0" v-model="addcollectFieldInfo.status" active-color="#13ce66"
                                active-value="ACTIVE" inactive-value="INACTIVE">
                            </el-switch>
                        </el-form-item>

                    </el-form>

                </div>
            </div>

        </el-dialog>


    </el-row>
</template>

<script>
    import collectionBar from '../../../components/collectionBar'
    import http from '../../../APIService/http'
    import moment from "moment";
    export default {
        name: "collectField",
        data() {
            return {
                tags: ['数据采集任务', '采集字段'],
                activeName: "",
                tabShow: {
                    showInstitution: false,
                    showHcp: false,
                    showRetailstore: false,
                    showDistributor: false,
                    showCustomtable: false,
                },
                subTitle: '',
                isfalse: false,
                fieldDetails: false,
                fieldDetails1: false,
                fieldCustomTableDetails: false,
                collectObject: [],
                addcollectFieldInfo: {
                    field_name: '',
                    field_id: '',
                    field_array: [],
                    sort: 1,
                    status: 'ACTIVE',
                    dept_id: [],
                    product_id: [],
                    start_date: '',
                    end_date: '',
                    reference_obj: ''
                },
                uploadcollectFieldInfo: {
                    field_name: '',
                    field_id: '',
                    sort: 1,
                    status: 'ACTIVE',
                    dept_id: [],
                    product_id: [],
                    key_id: '',
                    start_date: '',
                    end_date: '',
                    reference_obj: '',
                    default_value:''
                },
                mineStatusValue: '',
                data: [],
                productList: [],
                deptList: [],
                collectProfile: [],
                task_id: '',
                collectFieldList: [],
                reference_obj: [],
                field_props: {
                    value: 'field_id',
                    label: 'label',
                    multiple: true,
                },
                isDisable: false

            }
        },


        components: {
            collectionBar,
        },
        created() {
            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
            console.log(this.collectProfile)
            this.task_id = this.collectProfile.task_id
            this.subTitle = this.collectProfile.task_name
            this.getTaskField()
            this.getCollectObject()
            this.getProductList()
            this.getDeptList()

        },
        methods: {
            getFieldShowText(row) {
                if (row.label) {
                    return row.label;
                }
                return row.field_name;
            },
            getTaskField() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.task_id
                    }
                    http.post('/wapi/Collect/getCollectInfo', data).then(res => {
                        if (res.success == true) {
                            this.reference_obj = res.data[0].reference_obj
                            this.init()
                        }
                    })
                } catch (e) {
                    return e
                }
            },
            getCollectObject() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    task_id: this.task_id

                }
                http.post('/wapi/Collect/getCollectObject', data).then(res => {
                    if (res.success) {
                        this.collectObject = res.data
                    }
                })
            },

            handleAddClick() {
                this.data = [];
                this.fieldDetails1 = true
                this.addcollectFieldInfo = {
                    field_name: '',
                    field_id: '',
                    field_array: [],
                    status: 'ACTIVE',
                    dept_id: [],
                    product_id: [],
                    start_date: '',
                    end_date: '',
                    reference_obj: ''
                }
                if (this.collectFieldList.length > 0) {
                    this.addcollectFieldInfo.sort = this.collectFieldList[this.collectFieldList.length - 1].sort + 1
                } else {
                    this.addcollectFieldInfo.sort = 1
                }
                this.$refs["ruleForm1"].resetFields()
            },
            add() {
                this.$refs["ruleForm1"].validate(valid => {
                    if (!valid) {
                        return false
                    } else {
                        this.addcollectFiel()
                    }
                })
            },

            addcollectFiel() {
                // let temp_field_array = this.addcollectFieldInfo.field_array;
                // for (const item of this.collectFieldList) {
                //     for (const i in this.addcollectFieldInfo.field_array) {
                //         let sub_item = this.addcollectFieldInfo.field_array[i];
                //         if (item.field_id === sub_item[1]) {
                //             temp_field_array.splice(i, 1);
                //         }
                //     }
                // }

                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    task_id: this.task_id,
                    reference_obj: this.addcollectFieldInfo.reference_obj,
                    field_name: this.addcollectFieldInfo.field_name,
                    field_id: this.addcollectFieldInfo.field_id,
                    sort: this.addcollectFieldInfo.sort,
                    status: this.addcollectFieldInfo.status,
                    dept_id: this.addcollectFieldInfo.dept_id,
                    product_id: this.addcollectFieldInfo.product_id,
                    start_date: this.addcollectFieldInfo.start_date,
                    end_date: this.addcollectFieldInfo.end_date,
                    field_array: this.addcollectFieldInfo.field_array
                }
                http.post('/wapi/Collect/addCollectFieldList', data).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: "保存成功"
                        })
                        this.fieldDetails1 = false
                        this.getCollectFieldList()

                    }
                })
            },
            init() {
                this.activeName = "";
                this.reference_obj.forEach(element => {
                    if (element === "INSTITUTION") {
                        this.tabShow.showInstitution = true;
                        if (this.activeName === "") {
                            this.activeName = element;
                        }
                    } else if (element === "HCP") {
                        this.tabShow.showHcp = true;
                        if (this.activeName === "") {
                            this.activeName = element;
                        }
                    } else if (element === "RETAILSTORE") {
                        this.tabShow.showRetailstore = true;
                        if (this.activeName === "") {
                            this.activeName = element;
                        }
                    } else if (element === "DISTRIBUTOR") {
                        this.tabShow.showDistributor = true;
                        if (this.activeName === "") {
                            this.activeName = element;
                        }
                    } else if (element === "CUSTOMTABLE") {
                        this.tabShow.showCustomtable = true;
                        if (this.activeName === "") {
                            this.activeName = element;
                        }
                    }

                });
                this.getCollectFieldList();
            },
            getCollectFieldList(e) {
                if (e) {
                    this.activeName = e;
                }
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        task_id: this.task_id,
                        reference_obj: [this.activeName]
                    }
                    http.post('/wapi/Collect/getCollectFieldList', data).then(res => {
                        if (res.success) {
                            this.collectFieldList = res.data
                            console.log(this.collectFieldList)
                            this.collectFieldList.forEach(item => {
                                if (item.start_date && item.end_date) {
                                    item.date = moment(item.start_date).format("YYYY年MM月DD日") + '-' + moment(item.end_date).format("YYYY年MM月DD日")
                                } else if (item.start_date) {
                                    item.date = moment(item.start_date).format("YYYY年MM月DD日") + '-'
                                } else if (item.end_date) {
                                    item.date = '-' + moment(item.end_date).format("YYYY年MM月DD日")
                                } else {
                                    item.date = '-'
                                }
                            })
                            console.log(this.collectFieldList)

                            loading.close();
                            if (e) {
                                this.getField(e)
                            }
                        }
                    })

                } catch (e) {
                    loading.close()
                }
            },
            upload() {
                this.$refs["ruleForm"].validate(valid => {
                    if (!valid) {
                        return false
                    } else {
                        this.uploadcollectFiel()
                    }
                })
            },
            uploadcollectFiel() {
                console.log(this.uploadcollectFieldInfo.status)
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    task_id: this.task_id,
                    reference_obj: this.uploadcollectFieldInfo.reference_obj,
                    field_name: this.uploadcollectFieldInfo.field_name,
                    field_id: this.uploadcollectFieldInfo.field_id,
                    sort: this.uploadcollectFieldInfo.sort,
                    default_value: this.uploadcollectFieldInfo.default_value,
                    status: this.uploadcollectFieldInfo.status,
                    dept_id: this.uploadcollectFieldInfo.dept_id,
                    product_id: this.uploadcollectFieldInfo.product_id,
                    start_date: this.uploadcollectFieldInfo.start_date,
                    end_date: this.uploadcollectFieldInfo.end_date,
                    primary_key: this.uploadcollectFieldInfo.primary_key,
                    mandatory: this.uploadcollectFieldInfo.mandatory,
                    readonly: this.uploadcollectFieldInfo.readonly,
                    key_id: this.uploadcollectFieldInfo.key_id,
                }
                http.post('/wapi/Collect/uploadCollectFieldList', data).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: "保存成功"
                        })
                        this.fieldDetails = false
                        this.fieldCustomTableDetails = false;
                        this.getCollectFieldList()

                    }
                })
            },
            close() {

                this.fieldCustomTableDetails = false;
                this.fieldDetails = false
                this.fieldDetails1 = false
                this.isfalse = false
            },


            tabHandleClick(item) {
                this.activeName = item.name;
                this.getCollectFieldList()
            },

            handleBackClick() {
                this.$router.push({ name: 'CollectionHome' })
            },
            handleDetail(row, reference_obj) {
                console.log(row)
                this.uploadcollectFieldInfo = {
                    field_name: '',
                    field_id: '',
                    sort: 1,
                    default_value:'',
                    key_id: '',
                    status: 'ACTIVE',
                    readonly: "F",
                    primary_key: "F",
                    mandatory: "F",
                    dept_id: [],
                    product_id: [],
                    start_date: '',
                    end_date: '',
                    reference_obj: ''
                }
                // this.$refs["ruleForm"].resetFields()
                if (row.deptList.length > 0) {
                    row.deptList.forEach(item => {
                        this.uploadcollectFieldInfo.dept_id.push(item.key)
                    })
                }
                if (row.proList.length > 0) {
                    for (let i = 0; i < row.proList.length; i++) {
                        this.uploadcollectFieldInfo.product_id.push([row.proList[i].product_id])
                    }

                }
                if (row.skuList.length > 0) {
                    for (let i = 0; i < row.skuList.length; i++) {
                        this.uploadcollectFieldInfo.product_id.push([row.skuList[i].product_id, row.skuList[i].sku_id])
                    }
                }
                this.uploadcollectFieldInfo.key_id = row.key_id
                this.uploadcollectFieldInfo.field_name = row.field_name
                this.uploadcollectFieldInfo.field_id = row.field_id
                this.uploadcollectFieldInfo.sort = row.sort
                this.uploadcollectFieldInfo.default_value = row.default_value
                this.uploadcollectFieldInfo.status = row.status
                // this.uploadcollectFieldInfo.product_id = row.product_id ? row.product_id : ''
                this.uploadcollectFieldInfo.start_date = row.start_date
                this.uploadcollectFieldInfo.end_date = row.end_date
                this.uploadcollectFieldInfo.primary_key = row.primary_key
                this.uploadcollectFieldInfo.mandatory = row.mandatory
                this.uploadcollectFieldInfo.readonly = row.readonly
                this.uploadcollectFieldInfo.reference_obj = row.reference_obj
                console.log(this.uploadcollectFieldInfo)
                this.isfalse = true
                if (reference_obj && reference_obj === "CUSTOMTABLE") {
                    this.fieldCustomTableDetails = true;
                } else {
                    this.fieldDetails = true
                }

            },
            handleNodeClick(data, node) {
                console.log(data, node)
                if (data.field_id) {
                    if (data.tenant_id == 'retaium') {
                        this.uploadcollectFieldInfo.builtin = 'T'
                    } else {
                        this.uploadcollectFieldInfo.builtin = 'F'
                    }
                    this.uploadcollectFieldInfo.field_id = data.field_id
                    this.uploadcollectFieldInfo.field_name = data.label
                }

            },
            handleNodeClick1(data, node) {
                console.log(data, node)
                if (data.data_type == 'ARRAY') {
                    this.isDisable = true
                } else {
                    this.isDisable = false
                }
                if (data.field_id) {
                    if (data.tenant_id == 'retaium') {
                        this.addcollectFieldInfo.builtin = 'T'
                    } else {
                        this.addcollectFieldInfo.builtin = 'F'
                    }
                    this.addcollectFieldInfo.field_id = data.field_id
                    this.addcollectFieldInfo.field_name = data.label
                }

            },
            getField(e) {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        reference_obj: e
                    }
                    this.data = [{ label: '系统内置', children: [] }]
                    http.post('/wapi/Collect/getCollectField', data).then(res => {
                        if (res.success) {
                            for (let i = 0; i < res.data.ary1.length; i++) {
                                this.data[0].children.push(res.data.ary1[i])
                            }
                            for (let i = 0; i < res.data.ary2.length; i++) {
                                if(res.data.ary2[i].group_id==this.collectProfile.template_id){
                                    this.data.push(res.data.ary2[i])
                                }
                            }

                            this.resetAddCollectField();
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            resetAddCollectField() {
                let tempCollectField = [];
                for (const item of this.collectFieldList) {
                    tempCollectField.push([undefined, item.field_id]);
                    for (const data_item of this.data) {
                        for (const data_sub_item of data_item.children) {
                            if (data_sub_item.field_id === item.field_id) {
                                data_sub_item.disabled = true;
                            }
                        }
                    }
                }
            },

            getProductList() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                }
                http.post('/wapi/Collect/getProductSkuList', data).then(res => {
                    if (res.success) {
                        this.productList = res.data
                    }
                })
            },
            getDeptList() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    category: 'STANDARD_DEPT'
                }
                http.post('/wapi/standard/getDeptList', data).then(res => {
                    if (res.success) {
                        this.deptList = res.data
                    }
                })
            },
            chooseTimeRange0(t) {
                let time1 = moment(t).valueOf()
                let time2 = moment(this.uploadcollectFieldInfo.end_date).valueOf()
                if (time1 >= time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.uploadcollectFieldInfo.end_date = ''
                }

            },
            chooseTimeRange1(t) {

                let time1 = moment(t).valueOf()
                let time2 = moment(this.uploadcollectFieldInfo.start_date).valueOf()


                if (time1 <= time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.uploadcollectFieldInfo.end_date = ''
                }
            },
            chooseTimeRange2(t) {
                let time1 = moment(t).valueOf()
                let time2 = moment(this.addcollectFieldInfo.end_date).valueOf()
                if (time1 >= time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.addcollectFieldInfo.end_date = ''
                }

            },
            chooseTimeRange3(t) {

                let time1 = moment(t).valueOf()
                let time2 = moment(this.addcollectFieldInfo.start_date).valueOf()


                if (time1 <= time2) {
                    this.$message({
                        type: "warning",
                        message: "结束日期应晚于开始日期"
                    })
                    this.addcollectFieldInfo.end_date = ''
                }
            },

        },
        updated() {
            console.log(this.uploadcollectFieldInfo.product_id)
        }
    }
</script>

<style scoped>
    #collectField>>>.el-dialog__header {
        padding-top: 0
    }

    #collectField>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
    }

    #collectField>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }

    #collectField>>>.el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #collectField>>>.collectField_star label:after {
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/collectField.vue